import type { SVGProps } from 'react';

const SvgLinkedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M11.975 15.189v-4.933c0-1.178-.023-2.691-1.595-2.691-1.597 0-1.84 1.282-1.84 2.604v5.02H5.472V5.044h2.944v1.385h.041c.41-.796 1.411-1.639 2.904-1.639 3.105 0 3.678 2.101 3.678 4.834v5.565h-3.064ZM2.013 3.657c-.984 0-1.778-.819-1.778-1.83C.235.819 1.03 0 2.013 0c.981 0 1.778.819 1.778 1.827 0 1.011-.797 1.83-1.778 1.83Zm1.535 11.532H.478V5.044h3.07v10.145Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgLinkedIn;
